import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Icon, { Icons } from '../../Icon/Icon';

import './HeaderBackButton.scss';

const ICON_SIZE = 24;

const HeaderBackButton = () => {
	const theme = useSelector(state => state?.app?.theme);

	const navigate = useNavigate();

	const goBack = () => {
		navigate(-1);
	};

	return (
		<button className={classNames('HeaderBackButton', 'HeaderBackButton__' + theme)} onClick={goBack}>
			<Icon type={Icons.ARROW_CHEVRON_BOLD} width={ICON_SIZE} height={ICON_SIZE} />
		</button>
	);
};

export default HeaderBackButton;
